export const stableSort = (rows, orderBy, order) => {
    if (!rows || rows?.length < 1) return [];

    const onSort =
        order === 'desc'
            ? (a, b) => ((b[orderBy] ?? '') < (a[orderBy] || '') ? -1 : 1)
            : (a, b) => -((b[orderBy] ?? '') > (a[orderBy] ?? '') ? 1 : -1);

    const stabilizedThis = rows.map((el, i) => [el, i]);
    stabilizedThis.sort((a, b) => {
        const order = onSort(a[0], b[0]);
        return order !== 0 ? order : a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

export const sortByEndDate = (arr) => {
    return arr.length < 2
        ? arr
        : arr.sort(
              (a, b) =>
                  (b.endDate === null) - (a.endDate === null) ||
                  +(b.endDate > a.endDate) ||
                  -(b.endDate < a.endDate)
          );
};

export const sortDateTime = (arr) => {
    return arr.length < 2
        ? arr
        : arr
              .slice()
              .sort((a, b) =>
                  (a.date + a.startTime.trim()).localeCompare(b.date + b.startTime.trim())
              );
};

/**
 * Sorts an array numerically, accounting for text prefixes and suffixes.
 * Comparison order: prefix (alphabetical) → number (numeric) → suffix (alphabetical)
 *
 * @param {Array} arr - Array to sort (strings or objects)
 * @param {string} [keyName] - Property name to sort by if array contains objects
 * @returns {Array} Sorted array
 *
 * @example
 * naturalSort(['10a', '1.1b', '2a', '1a']) // ['1a', '1.1b', '2a', '10a']
 * naturalSort(objects, 'name')
 */
export const naturalSort = (arr, keyName = null) => {
    const NUMERIC_PATTERN = /^([^\d]*)(\d+(?:\.\d+)?)(.*)$/;

    const parse = (str) => {
        const match = str.match(NUMERIC_PATTERN);
        if (!match) return ['', null, str];

        const [, prefix, numStr, suffix] = match;
        return [prefix, parseFloat(numStr), suffix];
    };

    return arr.slice().sort((a, b) => {
        const [prefixA, numA, suffixA] = parse(keyName ? a[keyName] : a);
        const [prefixB, numB, suffixB] = parse(keyName ? b[keyName] : b);

        if (prefixA !== prefixB) return prefixA.localeCompare(prefixB);
        if (numA !== numB) return (numA ?? Infinity) - (numB ?? Infinity);
        return suffixA.localeCompare(suffixB);
    });
};
